import React from 'react';
import { Box, ButtonNew as Button, ModalDialogNew, Spacer, Text, TextProps } from '@jfs/ui-new';
import { Icon } from '@jfs/ui-new/src/comps/IconNew';
import { Title } from '../Title';
import { overflow } from 'styled-system';

interface InactivityDialogProps {
  show: boolean;
  message: string;
  type: 'POSITIVE' | 'NEGATIVE';
  onPress: () => void;
  children?: React.ReactNode;
}

export const VerticleDrawerDialog = ({ show, message, type, onPress, children }: InactivityDialogProps) => {
  const isPositive = type === 'POSITIVE';

  return (
    <ModalDialogNew type={'bottom'} show={show} backgroundColor="TRANSPARENT">
      <Box
        flexDirection={'column'}
        ph={16}
        pb={8}
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        alignItems={'center'}
        backgroundColor={'WHITE'}
        // overflow={'auto'}
      >
        <Box style={styles.closeIconContainer}>
          <Button
            type={'secondary'}
            onPress={onPress}
            borderColor={'TRANSPARENT'}
            underlayColor={'TRANSPARENT'}
          >
            <Icon id="CLOSE" size={20} color={isPositive ? 'BRAND_PRIMARY_RED' : 'BRAND_PRIMARY_RED'} />
          </Button>
        </Box>
        <Spacer size={24} />
        {children}
      </Box>
    </ModalDialogNew>
  );
};

const styles = {
  closeIconContainer: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1,
  },
  secondaryButtonText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_PRIMARY_RED',
  } as TextProps,
};